import { render, staticRenderFns } from "./CurveItem.vue?vue&type=template&id=99fd594a&scoped=true&"
import script from "./CurveItem.vue?vue&type=script&lang=js&"
export * from "./CurveItem.vue?vue&type=script&lang=js&"
import style0 from "./CurveItem.vue?vue&type=style&index=0&id=99fd594a&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99fd594a",
  null
  
)

export default component.exports